var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    rx: 3.5,
    fill: "#18181B",
    stroke: "#18181B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1019 5.53568L12.097 5.52978L12.0917 5.52428C11.9316 5.35848 11.6734 5.35805 11.5127 5.52301L7.3275 9.72658L5.29444 7.67933C5.13384 7.51427 4.87553 7.51466 4.71539 7.68049C4.55867 7.84279 4.55867 8.09889 4.71539 8.26119L4.71538 8.2612L4.71735 8.26319L6.83367 10.3943C6.96658 10.5313 7.14747 10.5996 7.3157 10.5996C7.49817 10.5996 7.66659 10.5295 7.79763 10.3944L12.0631 6.11028C12.2364 5.94903 12.2349 5.69639 12.1019 5.53568ZM7.41279 9.81247L7.41124 9.8109C7.41178 9.81143 7.41228 9.81196 7.41278 9.81248L7.41279 9.81247Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.2bccfd4705cc5087d1c365dd20d9c44e.svg";
export { ForwardRef as ReactComponent };